<template>
	<div>
		<v-container fluid class="actions-bar-container">
			<app-table
				selectable
				compact
				contained
				sticky-header
				class="actions-bar-table is-not-selectable"
				name="resources"
				:columns="columns"
				:column-widths="{ 1: '190px', 2: '145px', 3: '185px', 4: '70px', 5: '65px' }"
				:rows="actions"
				:check-all="checkAll"
				@on-selected-all="allIsSelected"
				@row-is-selected="rowIsSelected"
			>
				<template slot="rows" slot-scope="props">
					<td class="action-text-cell" :title="getName(props.row)">
						{{ getName(props.row) }}
					</td>
					<td class="action-text-cell" :title="props.row.code">
						{{ props.row.code }}
					</td>
					<td class="action-text-cell" :title="props.row.codeWeb">
						{{ props.row.codeWeb || '—' }}
					</td>
					<td class="action-input-cell">
						<input
							v-model="props.row.numFragment"
							class="action-inline-input action-number-input"
							type="number"
							min="0"
							aria-label="Fragment móvil"
						>
					</td>
					<td class="action-input-cell">
						<input
							v-model="props.row.position"
							class="action-inline-input action-position-input"
							type="number"
							min="0"
							max="20"
							aria-label="Posición"
						>
					</td>
				</template>
			</app-table>
		</v-container>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="!hasChanges"
				@accept-button-clicked="saveChanges"
				@cancel-button-clicked="$emit('close-modal')"
			/>
		</section>
	</div>
</template>

<script>
import lib from '@/lib';

const { getDeeper } = lib;

function getName(row) {
	return getDeeper('languages', 'es', 'name')(row);
}

function allIsSelected(value) {
	this.checkAll = value;
	this.$emit('select-all', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function serializedActions() {
	return JSON.stringify(this.actions.map(action => ({
		id: action.id,
		isSelected: Boolean(action.isSelected),
		numFragment: Number(action.numFragment || 0),
		position: Number(action.position || 0),
	})));
}

function hasChanges() {
	return Boolean(this.selectionBaseline) &&
		this.serializedActions !== this.selectionBaseline;
}

function saveChanges() {
	if (!this.hasChanges) return;
	this.$emit('save-data');
}

function data() {
	return {
		checkAll: false,
		selectionBaseline: '',
		columns: [
			{ id: 1, name: 'Nombre', checked: true, visible: true },
			{ id: 2, name: 'Código', checked: true, visible: true },
			{ id: 3, name: 'URL Web', checked: true, visible: true },
			{ id: 4, name: 'Frag. Movil', checked: true, visible: true },
			{ id: 5, name: 'Posición', checked: true, visible: true },
		],
	};
}

export default {
	name: 'actions-bar',
	computed: {
		hasChanges,
		serializedActions,
	},
	data,
	methods: {
		allIsSelected,
		rowIsSelected,
		getName,
		saveChanges,
	},
	props: {
		actions: {
			default: () => [],
			type: Array,
		},
	},
	watch: {
		actions: {
			immediate: true,
			handler() {
				if (this.selectionBaseline || !this.actions.length) return;
				this.$nextTick(() => {
					this.selectionBaseline = this.serializedActions;
					this.checkAll = this.actions.length > 0 &&
						this.actions.every(action => action.isSelected);
				});
			},
		},
	},
};
</script>

<style lang="scss">
.actions-bar-container {
	padding: 6px 10px 0 !important;
}

.actions-bar-table.app-table-wrapper {
	max-height: calc(100vh - 150px) !important;
	overflow-x: auto !important;
	overflow-y: auto !important;
}

.actions-bar-table .table-list {
	table-layout: auto;

	> thead {
		position: sticky !important;
		top: 0;
		z-index: 4;
	}

	> tbody > tr,
	> tbody > tr > td {
		height: 34px !important;
		min-height: 34px !important;
	}

	> tbody > tr > td {
		font-size: 10px !important;
		padding: 2px 7px !important;
	}

	.action-input-cell {
		padding-left: 5px !important;
		padding-right: 5px !important;
	}

	.action-text-cell {
		white-space: nowrap;
	}

	> thead > tr:last-child > th:not(:first-child),
	> tbody > tr > td:not(:first-child) {
		padding-left: 6px !important;
		padding-right: 6px !important;
	}
}

.action-inline-input {
	background: #fff !important;
	border: 1px solid #d6e1ea !important;
	border-radius: 6px;
	box-shadow: none;
	color: #314a60;
	font-size: 11px;
	height: 27px;
	outline: none;
	padding: 0 8px;
	text-align: left;
	width: 52px;

	&:focus {
		border-color: #1A4338 !important;
		box-shadow: 0 0 0 2px rgba(33, 150, 243, .1);
	}
}

.action-position-input {
	text-align: center;
	width: 60px;
}

.action-number-input { text-align: center; }

.action-input-cell { text-align: center !important; }
</style>



// WEBPACK FOOTER //
// src/components/actions/actions-bar.vue